/** Address Helper */

/**
 * Turn the address as returned from the Accounts API into a string
 * @param  {Object} [address={}] Address split up into individual components
 * @return {String}              Address as a string e.g. Australia St, Camperdown NSW 2050, Australia
 */
export const displayAddress = (address = {}) => {
  const address_obj = {
    display: '',
    address_line_1: address.address_line_1,
    address_line_2: address.address_line_2,
    city: address.city,
    state: address.state,
    zip: address.zip,
    country: address.country,
  };

  const enterData = (data) => {
    if (data?.length) {
      address_obj.display += `${data}, `;
    }
  };

  enterData(address.address_line_1);
  enterData(address.address_line_2);
  enterData(address.city);
  enterData([address.state, address.zip].filter(Boolean).join(' '));
  enterData(address.country);

  address_obj.display = address_obj.display.substring(0, address_obj.display.length - 2);

  return address_obj;
};

/**
 * Turn a address string into an array suitable for passing to the Accounts API
 * @param  {String} [string=''] 	Address as a string e.g. Australia St, Camperdown NSW 2050, Australia
 * @return {object}					Address split up into individual components
 */
export const saveAddress = (string = '') => {
  const address = {
    address_line_1: '',
    address_line_2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  };

  // Split the string into parts.
  const addressParts = string.split(', ').reverse();

  // Split the combined state and zip into parts.
  const addressStateParts = typeof addressParts[1] === 'undefined' ? [] : addressParts[1].trim().split(' ');

  // Remove combined state and zip from address array.
  addressParts.splice(1, 1);

  // Re-add state and zip back into the address array as individual elements.
  addressParts.splice(1, 0, addressStateParts[1] || '', addressStateParts[0] || '');

  // Populate the address object with the correct parts.
  address.country = addressParts[0] || '';
  address.zip = addressParts[1] || '';
  address.state = addressParts[2] || '';
  address.city = addressParts[3] || '';
  address.address_line_2 = addressParts[4] || '';
  address.address_line_1 = addressParts[5] || '';

  return address;
};

/**
 * Turn a Google address into an array suitable for passing to the Accounts API
 * @param  {Object} google_address [address={}] Address split up into individual components
 * @return {object}					Address split up into individual components
 */
export const saveGoogleAddress = (google_address = {}) => {
  const address = {
    address_line_1: '',
    address_line_2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  };

  google_address.forEach((element) => {
    address.address_line_1 += element.types.indexOf('subpremise') < 0 ? '' : `${element.long_name}/`;
    address.address_line_1 += element.types.indexOf('street_number') < 0 ? '' : element.long_name;
    address.address_line_1 += element.types.indexOf('route') < 0 ? '' : ` ${element.long_name}`;
    address.address_line_2 += element.types.indexOf('sublocality_level_1') < 0 ? '' : element.long_name;
    address.city += element.types.indexOf('locality') < 0 ? '' : element.long_name;
    address.state += element.types.indexOf('administrative_area_level_1') < 0 ? '' : element.short_name;
    address.zip += element.types.indexOf('postal_code') < 0 ? '' : element.long_name;
    address.country += element.types.indexOf('country') < 0 ? '' : element.long_name;
  });

  return address;
};

export const stateAbbreviation = (stateName) => {
  const states = [
    { long_name: 'New South Wales', short_name: 'NSW' },
    { long_name: 'Queensland', short_name: 'QLD' },
    { long_name: 'South Australia', short_name: 'SA' },
    { long_name: 'Tasmania', short_name: 'TAS' },
    { long_name: 'Victoria', short_name: 'VIC' },
    { long_name: 'Western Australia', short_name: 'WA' },
  ];
  if (stateName) {
    const found = states.find((state) => state.long_name.toLowerCase() === stateName.toLowerCase());
    return found !== undefined ? found.short_name : stateName;
  }
  return stateName;
};
